export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-01_EN-07.221ac5d1.jpg";